import AuthForm from "./components/AuthForm";

export default AuthForm;
